<script setup>
// 1. 使用 defineProps 來定義可以接收的 props
const props = defineProps({
  errorMessage: {
    type: String,
    // 2. 如果父層沒有傳遞 errorMessage，則使用這個預設訊息
    default: '發生了一點錯誤...'
  }
});

const handleReset = () => {
  // Reload the page
  window.location.reload();
};
</script>

<template lang="pug">
  .container
    //- content
    .wrap
      //- 錯誤
      .error-container#errorPopup
        img(src="/public/error.svg", alt="error")
        //- 3. 將寫死的文字改成從 props 讀取
        p {{ errorMessage }}
        p 不過沒關係，這只是小插曲！請嘗試重新整理，或返回上一頁繼續操作。
        button.standard(@click="handleReset") 重新整理
</template>

<style scoped lang="sass">
@use '@assets/styles/common' as *
@use '@assets/styles/mixin' as *

.container
  padding-top: unset
  .wrap
    padding: 10%

.error-container
  > img
    +size(200px)
  > p
    +font(40px,500)
    line-height: 2
    color: #6B6B6B
    &:last-of-type
      +font(24px,500)
  button.standard
    width: 160px
    margin-top: 24px

</style>
